import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const Accept: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper 
    onClick={onClick}
    divClassName={divClassName}
  >
    <svg 
      width="16" 
      height="12" 
      viewBox="0 0 16 12" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M5.09091 9.49254L1.27273 5.73134L0 6.98507L5.09091 12L16 1.25373L14.7273 0L5.09091 9.49254Z" 
        fill="#3273E1"
      />
    </svg>
  </SvgWrapper>
);
